import { InferOutput, number } from 'valibot'

export const ArmorSchema = number()

export type Armor = InferOutput<typeof ArmorSchema>
